module.exports = __webpack_public_path__ + "static/media/backdrop.370e90ae.jpg";